/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { ContentCardOrientation } from '@airasia-phoenix/react-native/widgets/HorizontalContentCardView/ContentDetailsView';

import Constants from './constants';
import {
  FlightDealsItemAPIResponse,
  FlightsDealsCarouselItemProps,
} from './types';

export const mapToVerticalContentCardProps = (
  data: FlightDealsItemAPIResponse[],
  onImageError: (item: FlightDealsItemAPIResponse) => void,
  onItemPress?: (item: FlightDealsItemAPIResponse) => void,
): FlightsDealsCarouselItemProps[] => {
  //@ts-expect-error return is not working.
  return data.map((item) => {
    const hasPrice = item.priceText?.length && item.price?.length;

    return {
      onPress: () => {
        onItemPress?.(item);
      },
      model: item,
      favouriteIcon: false,
      imageHeight: Constants.IMAGE_HEIGHT,
      imageWidth: Constants.CARD_WIDTH,
      image: {
        source: { uri: item.image },
        cacheProps: {
          priority: 'normal',
          cachePolicy: 'immutable',
        },
        onError: () => onImageError(item),
      },
      contentDetailsPropsValues: {
        orientation: ContentCardOrientation.VERTICAL,
        primaryText: item.title ?? '',
        secondaryText: item.subTitle ?? '',
        valueStarting: hasPrice ? item.priceText : undefined,
        value: hasPrice ? item.price : undefined,
      },
    };
  });
};
